module.exports = __webpack_public_path__ + "img/Group 848.8a9b5bad.png";